import { render } from "./classroom.vue?vue&type=template&id=df270f22"
import script from "./classroom.vue?vue&type=script&lang=ts"
export * from "./classroom.vue?vue&type=script&lang=ts"
script.render = render

export default script